"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/teamSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSectionCirclesItem = {
    key: Key | null | undefined;
    /** Detected variants: "circle" */
    className?: string;
};

type TeamSection36FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Michael Adams" | "Grace Lewis" | "Madison Wright" | "Aiden Roberts" */
    a0Text: ReactNode;
    /** Detected variants: "Mind-Body Therapy Specialist" | "Nutritional Health Coach" | "Physical Wellness Director" | "Preventive Medicine Physician" */
    p0Text: ReactNode;
    /** Detected variants: "Diana Williams" | "Grace Lewis" | "Madison Wright" | "Aiden Roberts" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/team/team-nine-2.jpg" | "/Templates/Doccure/img/team/team-nine-1.jpg" | "/Templates/Doccure/img/team/team-nine-4.jpg" | "/Templates/Doccure/img/team/team-nine-3.jpg" */
    src: string;
    /** Detected variants: "col-xl-3 col-sm-6 d-flex wow fadeInUp" */
    className?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "team-item-seventeen flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "view link" */
    ariaLabel?: string;
    /** Detected variants: "view-icon" */
    a0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "team-content" */
    div0ClassName2?: string;
    /** Detected variants: "#" */
    a0Href?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeSeventeenTeamSectionGeneratedProps = {
    divDiv0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Meet Our Expert Practitioners" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "A dedicated team of certified wellness professionals committed to guiding your transformation" */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "#" */
    sectionDiv0Div2A0AHref?: string;
    /** Default: "More Team Members" */
    sectionDiv0Div2A0Span0SpanText?: ReactNode;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/blog-bg-04.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    teamSectionCircles: TeamSectionCirclesItem[];
    teamSection36FadeInUps: TeamSection36FadeInUpsItem[];
    teamSectionCirclesItemWrapper?: (item: TeamSectionCirclesItem, content: ReactNode) => ReactNode;
    teamSectionCirclesRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsItemWrapper?: (item: TeamSection36FadeInUpsItem, content: ReactNode) => ReactNode;
    teamSection36FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsImageVisible?: boolean;
    teamSection36FadeInUpsImageRenderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsH3Visible?: boolean;
    teamSection36FadeInUpsH3Renderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection36FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeSeventeenTeamSectionGenerated: FC<HomeSeventeenTeamSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Meet Our Expert Practitioners",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "A dedicated team of certified wellness professionals committed to guiding your transformation",
    sectionDiv0Div2A0AHref = "#",
    sectionDiv0Div2A0Span0SpanText = "More Team Members",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/blog-bg-04.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    teamSectionCircles,
    teamSection36FadeInUps,
    teamSectionCirclesItemWrapper,
    teamSectionCirclesRenderer,
    teamSection36FadeInUpsItemWrapper,
    teamSection36FadeInUpsRenderer,
    teamSection36FadeInUpsImageVisible,
    teamSection36FadeInUpsImageRenderer,
    teamSection36FadeInUpsH3Visible,
    teamSection36FadeInUpsH3Renderer,
    teamSection36FadeInUpsImageProps,
    teamSection36FadeInUpsH3Props,
}) => {
    return (
        <section className="team-section-seventeen section pb-0">
            <div className="container">
                <div className="section-header section-header-seventeen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title text-gradient" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        teamSection36FadeInUps,
                        (item: TeamSection36FadeInUpsItem) => (
                            <div className={item.className ?? "col-xl-3 col-sm-6 d-flex wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-seventeen flex-fill"}>
                                    {renderItemNode(teamSection36FadeInUpsImageVisible, teamSection36FadeInUpsImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt} {...(typeof teamSection36FadeInUpsImageProps === "function" ? teamSection36FadeInUpsImageProps(item) : (teamSection36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                    <div className={item.div0ClassName2 ?? "team-content"}>
                                        {renderItemNode(teamSection36FadeInUpsH3Visible, teamSection36FadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof teamSection36FadeInUpsH3Props === "function" ? teamSection36FadeInUpsH3Props(item) : (teamSection36FadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div0H30H3Props === "function" ? divDiv0Div0H30H3Props(item) : (divDiv0Div0H30H3Props ?? {}))}>
                                                <a href={item.a0Href ?? "#"}>{item.a0Text}</a>
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                        <a href={item.href ?? "#"} className={item.a0ClassName ?? "view-icon"} aria-label={item.ariaLabel ?? "view link"}>
                                            <i className={item.i0ClassName ?? "isax isax-arrow-right-1"}></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection36FadeInUpsItemWrapper,
                        teamSection36FadeInUpsRenderer
                    )}
                </div>
                <div className="view-top text-center">
                    <a href={sectionDiv0Div2A0AHref} className="theme-17-btn">
                        <span className="text">{sectionDiv0Div2A0Span0SpanText}</span>
                        <span className="icon">
                            <i className="isax isax-arrow-right-1"></i>
                        </span>
                        <div className="container-stars">
                            <div className="stars"></div>
                        </div>
                        <div className="glow">
                            {renderCollectionNode(
                                teamSectionCircles,
                                (item: TeamSectionCirclesItem) => (
                                    <div className={item.className ?? "circle"} key={item.key}></div>
                                ),
                                teamSectionCirclesItemWrapper,
                                teamSectionCirclesRenderer
                            )}
                        </div>
                    </a>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid team-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSeventeenTeamSectionGenerated;
